import '@total-typescript/ts-reset';
import Whiteboard from './Whiteboard';

export default Whiteboard;
export { NonCollaborativeWhiteboard } from './NonCollaborativeWhiteboard';

export { validateAIResponse } from './utils/jsonValidator';

// TODO move this to a shared location so we don't have to export from whiteboards
export { default as SelectField } from './components/common/SelectField';

export { type FayeClient } from './types';
export { default as WhiteboardController } from './controllers/WhiteboardController';

export type {
  RelatedRecordManager,
  RecordLinkManager,
  RecordLinkOption,
  HierarchyImportRelationshipType,
  FetchOptions,
  HierarchyNode,
  HierarchyResult,
} from './types';

export type { WhiteboardProps } from './Whiteboard';

export { type WhiteboardOperation } from './services/assistant';
